import { ueQuickContract, ueContract } from "../contract/useContract.js";
import { RunbitProxyAddress, RunbitProxyAbi } from "../contract/address.js";
import { ethers } from "ethers";
import { getUserShoesInfo, getShoesState, getShoesInfo } from "../api";

export async function getUserInfo(account) {
  console.log("--- get userInfo start ---");
  console.log("accout", account);
  console.log("RunbitProxyContractAddress", RunbitProxyAddress);
  return ueQuickContract(RunbitProxyAddress, RunbitProxyAbi).then(
    async (contract) => {
      const shoesInfo = await getUserShoesInfo({ addr: account });

      console.log("shoesInfo", shoesInfo);
      return contract.getUserInfo(account).then(async (info) => {
        console.log("info", info);
        let results = [];
        if (info.equips.length) {
          const ids = info.equips.map((e) => e.id.toNumber()).join(",");

          const shoeInfos = await getShoesInfo({
            token_id: ids,
            lang: (localStorage.getItem("RUNBIT_LANG")|| "cn") === 'en' ? 'en' : 'cn', 
          });
          await Promise.all(
            info.equips.map(async (e) => {
              try {
                
                let equipCopy = {};
                Object.keys(e.meta).forEach((key, index) => {
                  equipCopy[key] =
                    typeof e.meta[key] === "number"
                      ? e.meta[key]
                      : e.meta[key].toNumber();
                });
                equipCopy.remain_durability = 0
                const item = {
                  img:  e.uri,
                  id: e.id.toNumber(),
                  equip: equipCopy,
                  level: equipCopy.level,
                  is_bind:false,
                  slot:-1,
                  is_synced: false
                }
                const shoeInfo = (shoeInfos || []).find(
                  (s) => s.nft_id === e.id.toNumber()
                );
                if(shoeInfo) {
                  item.img = 'https://game.runbit.io/eout/' + shoeInfo.uri
                  item.is_synced = true
                  item.is_bind = shoeInfo.is_binding
                  item.slot = shoeInfo.slot
                  item.name = shoeInfo.name
                  item.durability = shoeInfo.durability
                  item.income = shoeInfo.income
                  item.equip.remain_durability = shoeInfo.remain_durability;
                  item.equip.income_rate = shoeInfo.income_rate;
                  item.equip.income = shoeInfo.income;
                }
                results.push(item);
              } catch (e) {
                console.error(e);
              }
            })
          );
        }

        console.log("results", results);

        return {
          equips: results,
          equipBalance: ethers.utils.formatEther(info.equipBalance),
          ethBalance: ethers.utils.formatEther(info.ethBalance),
          rbBalance: ethers.utils.formatEther(info.rbBalance),
          today: info.today.toNumber(),
          ...shoesInfo.data,
        };
      });
    }
  );
}
